<lbca-message-feedback
	[show]="messageFeedObject.show"
	[type]="messageFeedObject.type"
	[autoclose]="messageFeedObject.autoclose"
	(closeFeed)="closeFeed()"
	[emoji]="messageFeedObject.emoji"
>
	<li messagePrimary>{{ messageFeedObject.primary }}</li>
	<li messageSecondary>{{ messageFeedObject.secondary }}</li>
</lbca-message-feedback>

<section class="inline-flex w-full mb-[40px]">
	<lbca-icon
		name="lucide:move-left"
		class="text-primary mt-[15px] mr-[15px]"
		(click)="actionBackRegister($event)"
	></lbca-icon>

	<div class="w-[60%]"></div>
	<div class="flex flex-col">
		@if (currentLegalRequest?.label) {
			<div class="text-xs text-font ml-[25px]">
				{{ claimLabelsDict['actual-phase'] }}
			</div>
		}
		<!-- <div *ngIf="!!registerPhase">
    <button  type="button" class="btn-type-4 ml-[25px]"
      [class.danger]="registerPhase.label !== currentLegalRequest.label"
    [class.primary]="registerPhase.label === currentLegalRequest.label"> {{ registerPhase.label }}</button>
  </div> -->
	</div>
</section>
@if (stepCreate === 1 || stepCreate === 2) {
	<section class="form-fields-sub-module-modal">
		<div class="ff-col-form overflow-x-hidden">
			<div class="ff-box-field ff-field-size-7">
				<lbca-select-tree
					[field]="getFieldv['typeId']"
					[label]="
						getFieldv['typeId'].value
							? claimLabelsDict['selected-claim']
							: claimLabelsDict['select-the-claim-type']
					"
					[error]="getFieldv['typeId'].error"
					[value]="getFieldv['typeId'].value"
					[disabled]="getFieldv['typeId'].disabled"
					[require]="getFieldv['typeId'].required"
					[cardData]="cardInfo"
					(changeValue)="changetypeIdValue($event, getFieldv['typeId'])"
				></lbca-select-tree>
			</div>
		</div>
		@if (stepCreate === 2) {
			<div class="ff-row-form overflow-x-hidden mt-[44px] mb-[44px]">
				<div class="ff-col-form overflow-x-hidden">
					<div class="ff-box-field ff-field-size-3">
						<lbca-entity-fields
							[forceType]="'RADIO'"
							[inline]="true"
							[field]="getFieldv['part']"
							[label]="getFieldv['part'].label"
							[error]="getFieldv['part'].error"
							[require]="getFieldv['part'].required"
							[value]="getFieldv['part'].value"
							[cardData]="cardInfo"
							(changeValue)="changeValueNewClaim($event, getFieldv['part'])"
						></lbca-entity-fields>
					</div>
				</div>
			</div>
			<div class="ff-row-form overflow-x-hidden">
				<div class="ff-box-field ff-field-size-3">
					<lbca-date-picker
						[labeled]="true"
						[label]="getFieldv['dateReference'].label"
						[require]="getFieldv['dateReference'].required"
						[error]="getFieldv['dateReference'].error"
						(changeValue)="changeValueNewClaim($event, getFieldv['dateReference'])"
						[calendarPosition]="'top'"
						[value]="getFieldv['dateReference'].value"
						[rules]="getFieldv['dateReference'].rules"
						[disabledDateRules]="getFieldv['dateReference'].disabledDateRules"
					></lbca-date-picker>
				</div>
				@if (!contentTypeText) {
					<div class="ff-box-field ff-field-size-3">
						<lbca-entity-fields
							[forceType]="'SELECT_ONE'"
							[field]="getFieldv['risk']"
							[label]="getFieldv['risk'].label"
							[error]="getFieldv['risk'].error"
							[require]="getFieldv['risk'].required"
							[value]="getFieldv['risk'].value"
							[cardData]="cardInfo"
							(changeValue)="changeValueNewClaim($event, getFieldv['risk'])"
						></lbca-entity-fields>
					</div>
				}
			</div>
			<!-- <div class="ff-row-form overflow-x-hidden mt-[44px]" *ngIf="registerPhase?.label !== currentLegalRequest.label">
      <div class="ff-box-field ff-field-size-7">
        <lbca-entity-fields
          [field]="getFieldv['faseatual']"
          [label]="getFieldv['faseatual'].label"
          [error]="[]"
          [require]="getFieldv['faseatual'].required"
          [value]="getFieldv['faseatual'].value"
          [cardData]="cardInfo"
          (changeValue)="changeValueNewClaim($event,getFieldv['faseatual'])">
        </lbca-entity-fields>
      </div>
    </div> -->
		}
	</section>
}

@if (stepCreate === 3) {
	<section class="form-fields-sub-module-modal">
		<div class="ff-col-form overflow-x-hidden">
			<div class="ff-box-field ff-field-size-7">
				<label class="text-xs text-font leading-[18px]" style="font-weight: bolder">
					Tipo de pedido
				</label>
				<p class="text-xs text-gray-700 leading-[18px]">{{ breadcrumbRegister }}</p>
			</div>
		</div>
		<div class="ff-row-form overflow-x-hidden h-[50px] mb-[52px]">
			<div class="ff-box-field w-[33%] relative">
				<label class="label-modal-register">{{ getFieldv['dateReference'].label }}</label>
				<div class="content-modal-register">
					<lbca-date-picker
						[labeled]="false"
						[tabeled]="true"
						[value]="getFieldv['dateReference'].value"
					></lbca-date-picker>
				</div>
			</div>
			<div class="ff-box-field w-[33%] relative">
				<label class="text-xs text-font leading-[18px]" style="font-weight: bolder">
					{{ getFieldv['risk'].label }}
				</label>
				<div class="content-modal-register">
					<lbca-entity-fields
						[forceType]="'SELECT_ONE'"
						[field]="getFieldv['risk']"
						[label]="getFieldv['risk'].label"
						[error]="[]"
						[labeled]="false"
						[tabeled]="true"
						[require]="getFieldv['risk'].required"
						[value]="getFieldv['risk'].value"
						[cardData]="cardInfo"
						(changeValue)="changeValueNewClaim($event, getFieldv['risk'])"
					></lbca-entity-fields>
				</div>
			</div>
			<div class="ff-box-field w-[33%] relative">
				<label class="text-xs text-font leading-[18px]" style="font-weight: bolder">
					{{ getFieldv['part'].label }}
				</label>
				<div class="content-modal-register">
					<lbca-entity-fields
						[forceType]="'SELECT_ONE'"
						[field]="getFieldv['part']"
						[label]="getFieldv['part'].label"
						[error]="[]"
						[labeled]="false"
						[tabeled]="true"
						[require]="getFieldv['part'].required"
						[value]="getFieldv['part'].value"
						[cardData]="cardInfo"
						(changeValue)="changeValueNewClaim($event, getFieldv['part'])"
					></lbca-entity-fields>
				</div>
			</div>
		</div>
		@if (!contentTypeText) {
			<div class="flex flex-row justify-between flex-wrap items-center mb-[64px] w-full">
				<div class="justify-center flex flex-col">
					<lbca-input-text
						[maskInput]="'CURRENCY_BR'"
						[labeled]="false"
						[componetHelperIconLeftStyle]="'total-inicial-light-white'"
						[loadingState]="loadingTotalInicial"
						[copyContent]="false"
						[label]="claimLabelsDict['total-initial']"
						[value]="valTotalInicial"
					></lbca-input-text>
				</div>
				<div class="justify-center flex flex-col">
					<lbca-input-text
						[maskInput]="'CURRENCY_BR'"
						[componetHelperIconLeftStyle]="'total-atualizado-light-white'"
						[loadingState]="loadingTotalAtualizado"
						[labeled]="false"
						[copyContent]="false"
						[label]="claimLabelsDict['total-updated']"
						[value]="valTotalAtualizado"
					></lbca-input-text>
				</div>
				<div class="justify-center flex flex-col">
					<lbca-input-text
						[maskInput]="'CURRENCY_BR'"
						[componetHelperIconLeftStyle]="'risco-light-white'"
						[loadingState]="loadingTotalRisco"
						[labeled]="false"
						[copyContent]="false"
						[label]="claimLabelsDict['total-risk-involved']"
						[value]="valTotalRisco"
					></lbca-input-text>
				</div>
			</div>
			@for (valores of field.fields; track valores) {
				@if (valores.type === 'ADDITIONAL_VALUES') {
					<lbca-additional-values
						[disabled]="disabled"
						[value]="additionalValuesData"
						[field]="valores.fields"
						(changeValue)="changeValueReceiver($event)"
						[cardData]="cardInfo"
					></lbca-additional-values>
				}
			}
		}
		@if (contentTypeText) {
			<div class="ff-row-form overflow-x-hidden">
				<div class="ff-box-field ff-field-size-7">
					<lbca-textarea
						[label]="getFieldv['description'].label"
						[error]="getFieldv['description'].error"
						[require]="getFieldv['description'].required"
						[textCount]="false"
						(changeValue)="changeValueNewClaim($event, getFieldv['description'])"
					></lbca-textarea>
				</div>
			</div>
		}
	</section>
}

@if (stepCreate === 1) {
	<section class="claim-bottom-modal-container">
		<ng-template [ngTemplateOutlet]="actionsControllers"></ng-template>
		<div class="flex">
			<button type="button" class="btn-secondary btn-type-2 ml-[4px]" (click)="closeModal()">
				{{ claimLabelsDict['btn-cancel'] }}
			</button>
			<button
				type="button"
				class="btn-primary btn-type-2 ml-[25px]"
				(click)="gotoStepCreate('next')"
			>
				{{ claimLabelsDict['btn-continue'] }}
			</button>
		</div>
	</section>
}

@if (stepCreate === 2) {
	<section class="claim-bottom-modal-container">
		<ng-template [ngTemplateOutlet]="actionsControllers"></ng-template>
		<div class="flex">
			<button
				type="button"
				class="btn-secondary btn-type-2 ml-[4px]"
				(click)="gotoStepCreate('prev')"
			>
				{{ claimLabelsDict['btn-back'] }}
			</button>
			<button
				type="button"
				class="btn-primary btn-type-2 ml-[25px]"
				(click)="gotoStepCreate('next')"
			>
				{{ claimLabelsDict['btn-continue'] }}
			</button>
		</div>
	</section>
}

@if (stepCreate === 3) {
	<section class="claim-bottom-modal-container">
		<ng-template [ngTemplateOutlet]="actionsControllers"></ng-template>
		<div class="flex">
			<button type="button" class="btn-secondary btn-type-2 ml-[4px]" (click)="closeModal()">
				{{ claimLabelsDict['btn-cancel'] }}
			</button>
			<button
				type="button"
				class="btn-primary btn-type-2 ml-[25px] load-action"
				[class.btn-motion-bg-gray-100]="submitButtonRegisterClaim"
				[disabled]="submitButtonRegisterClaim"
				(click)="createLegalRequest()"
			>
				@if (!submitButtonRegisterClaim) {
					{{ claimLabelsDict['btn-register-new-claim'] }}
				}
				@if (submitButtonRegisterClaim) {
					<img class="forgot-loading" src="./assets/icons/loading-points-bg-primary.svg" />
				}
			</button>
		</div>
	</section>
}

<ng-template #actionsControllers>
	<section class="controlers-action">
		<div
			(click)="gotoStepCreate('prev')"
			[class.active]="stepCreate === 2 || stepCreate === 1"
			class="btn-prevnext"
		></div>
		<div
			(click)="gotoStepCreate('next')"
			[class.active]="stepCreate === 3"
			[class.disabled]="!bulletStepThree"
			class="btn-prevnext"
		></div>
	</section>
</ng-template>

<ng-template #templateClaimRegistered>
	<div class="text-base text-font flex items-center justify-center show">
		{{ claimLabelsDict['claim-registered'] }}
		<div class="emojis-glasses icon-box ml-[16px]"></div>
	</div>
</ng-template>

<ng-template #templateStepRegisteredOrder>
	<div class="text-base text-font flex items-center justify-center show">
		Pedido cadastrado
		<div class="emojis-glasses icon-box ml-[16px]"></div>
	</div>
</ng-template>
